import React, { memo, SVGProps } from 'react'

export const Record = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 7.56768C9.56254 7.56768 7.58014 9.55584 7.58014 12C7.58014 14.4442 9.56254 16.4323 12 16.4323C14.4374 16.4323 16.4198 14.4442 16.4198 12C16.4198 9.55584 14.4374 7.56768 12 7.56768ZM12 14.9923C10.3574 14.9923 9.02014 13.6502 9.02014 12C9.02014 10.3498 10.3574 9.00768 12 9.00768C13.6425 9.00768 14.9798 10.3498 14.9798 12C14.9798 13.6502 13.6425 14.9923 12 14.9923Z"
      fill="currentColor"
    />
    <path
      d="M12 3.29952C7.22014 3.29952 3.33118 7.20096 3.33118 11.9962C3.33118 16.7914 7.22014 20.6928 12 20.6928C16.7798 20.6928 20.6697 16.7923 20.6697 11.9962C20.6697 7.2 16.7798 3.29952 12 3.29952ZM12 19.2528C8.01406 19.2528 4.77118 15.9974 4.77118 11.9962C4.77118 7.99488 8.01406 4.73856 12 4.73856C15.9859 4.73856 19.2297 7.99488 19.2297 11.9962C19.2297 15.9974 15.9869 19.2528 12 19.2528Z"
      fill="currentColor"
    />
  </svg>
))
